<template lang="pug">
page-template.px-lg-15.mb-10(title="Contato", fluid)
  grid-container.justify-center(
    cols="auto",
    cols-md="400px max-content",
    gap="40px"
  ) 
    grid-item(row-start="2", row-start-md="1")
      .text-h5.mb-3.font-weight-bold Fale Conosco
      contact-us(:action="server + '/rest/email/contact-us'")
    section
      .text-h5.mb-3.font-weight-bold
        .mb-2 Informações
      .mb-3(v-for="({ title, items }, i) in contact", :key="'a' + i")
        .text-body-1.font-weight-bold {{ title }}
        .d-flex.flex-column
          a.text-decoration-none.d-flex.align-center(
            v-for="({ title, link, icon, target }, i) in items",
            :key="'b' + i",
            :href="link",
            :target="target"
          )
            v-btn.text-none(icon)
              i.v-icon.small(:class="icon", style="font-size: 16px")
            span.text-body-2.world-break-all.black--text {{ title }}
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import ContactUs from "@/components/forms/ContactUs";
import { getTelLinkFromPhone } from "@/components/utils.js";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    branches() {
      return this.$rest("branches").list;
    },
    contact() {
      return this.branches.map((branche) => {
        const items = [];

        if (branche.local_link)
          items.push({
            title: branche.local_text,
            link: branche.local_link,
            icon: "fas fa-map-marker-alt",
            target: "_blank",
          });

        if (branche.tel)
          items.push({
            title: branche.tel,
            link: getTelLinkFromPhone(branche.tel || ""),
            icon: "fas fa-phone",
          });

        if (branche.email)
          items.push({
            title: branche.email,
            link: "mailto:" + branche.email,
            icon: "fas fa-envelope",
          });

        return {
          title: branche.title,
          items,
        };
      });
    },
  },
  methods: {
    getTelLinkFromPhone,
  },
  components: {
    ContactUs,
    PageTemplate,
  },
};
</script>
